import DataManagementContainer from "./containers/DataManagementContainer";
import "./styles.scss";
export default DataManagementContainer;
